import { render } from "./SavedNotesList.vue?vue&type=template&id=204d0115&scoped=true"
import script from "./SavedNotesList.vue?vue&type=script&lang=js"
export * from "./SavedNotesList.vue?vue&type=script&lang=js"

import "./SavedNotesList.vue?vue&type=style&index=0&id=204d0115&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204d0115"]])

export default __exports__